/**
 * Context for sharing the active drag ID across the kanban board component tree.
 *
 * dnd-kit's internal `isDragging` state resets synchronously when DragEnd fires,
 * before React can render the optimistic cache update. This causes a brief
 * "snap-back" where the dragged card becomes visible at its old position.
 *
 * This context provides our own controlled drag ID that only clears when we
 * explicitly call `setActive(null)` — after the optimistic update has been
 * queued in the same React batch. Cards use this instead of `isDragging` to
 * determine visibility.
 */
import { createContext, useContext } from "react";

const ActiveDragContext = createContext<string | null>(null);

export const ActiveDragProvider = ActiveDragContext.Provider;

/**
 * Returns the ID of the currently dragged item, or null if nothing is being dragged.
 * Use this instead of dnd-kit's `isDragging` to control card visibility during drag.
 */
export function useActiveDragId(): string | null {
  return useContext(ActiveDragContext);
}
